__turbopack_context__.v({
  "menuItem": "KebabMenu-module__QHR-Oq__menuItem",
  "menuItemContent": "KebabMenu-module__QHR-Oq__menuItemContent",
  "menuItemTooltipTrigger": "KebabMenu-module__QHR-Oq__menuItemTooltipTrigger",
  "menuLoading": "KebabMenu-module__QHR-Oq__menuLoading",
  "menuLoadingSpinner": "KebabMenu-module__QHR-Oq__menuLoadingSpinner",
});
